import React from 'react';

import { type ACTEvent, AdControlProvider } from '@atlassian/ad-control-toolkit';

import { AppRecommendationsContext } from '../../controllers/app-recommendations-provider';
import { ArkIntlProvider } from '../ark-intl-provider';

import { type AppRecommendationsProviderProps } from './types';

const AppRecommendationsProvider: React.FC<AppRecommendationsProviderProps> = ({
	onEvents,
	children,
	contextResolver,
	endpoint,
}) => {
	const handleOnEvents = React.useCallback(
		(event: ACTEvent) => {
			onEvents?.(event);
		},
		[onEvents],
	);

	return (
		<ArkIntlProvider>
			<AdControlProvider onEvents={handleOnEvents}>
				<AppRecommendationsContext.Provider
					value={{
						onEvents: handleOnEvents,
						contextResolver,
						endpoint,
					}}
				>
					{children}
				</AppRecommendationsContext.Provider>
			</AdControlProvider>
		</ArkIntlProvider>
	);
};

export default AppRecommendationsProvider;
